import React, {Fragment} from "react";
import {ActionType} from "../list/list/DataTable";
import {BetStatus, BetLog, ListBetLogsRequest } from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {Link} from "react-router-dom";
import {createInitialState, ListView, ListViewProps, ListViewState} from "../ListView";
import {SportsBetLogsService} from "../../services/SportsBetLogsService";
import {Form, FormListener} from "../form/Form";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Validators} from "../form/Validators";
import {Submit} from "../form/Submit";
import {SelectInput} from "../form/SelectInput";
import {ColumnType} from "../list/list/ColumnType";


interface State extends ListViewState<ListBetLogsRequest> {
    listRequest? : ListBetLogsRequest;
    form? : ListBetLogsRequest;
    validationMap? : any;
    lookupExpanded?: boolean;
    blockedUsers: boolean;
}

function userLinkRenderer(prop : any , name : any, item : BetLog) : any {
    if (item.userId) {
        return <Link key={"user-action" + item.userId} to={`/user/${item.userId}`}>{item.userId}</Link>;
    } else {
        return <div>n/a</div>;
    }
}

function amountRenderer(prop : any, name : any, item : BetLog) : any{
    return <div>{item.risk} {item.currency}</div>
}

export class BetLogsListView extends ListView<State, ListBetLogsRequest> implements FormListener<ListBetLogsRequest>{

    columns = [
        { property : "id", name : "ID"},
        { property : "betId", name : "Bet Id",
            renderer: (property: string, name: string, item: BetLog) => {
                return <Link key={"user-bet-action" + item.betId} to={`/sportsbetting/bet/${item.betId}`}>{item.betId}</Link>;
            }
        },
        { property : "userId", name : "User Id", renderer: userLinkRenderer },
        { property : "betType", name : "Type", type: ColumnType.ENUM },
        { property : "provider", name : "Provider" },
        { property : "amount", name : "Amount", renderer: amountRenderer },
        { property : "integration", name : "Integration"},
        { property : "created", name : "Created", type : ColumnType.DATE},
        { property : "gradedDate", name : "Graded", type : ColumnType.DATE},
        { property : "status", name : "Status", type: ColumnType.ENUM},
        { property : "description", name : "Description"},
        { property : "result", name : "Result", type: ColumnType.ENUM},
    ];

    actions = [
        { id : "betLogView", name : "View", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/sportsbetting/bet-log/" + item.id }
    ];
    service : SportsBetLogsService;

    date:any = new Date();
    initialState : ListBetLogsRequest = {
        limit: 20,
        orderBy: "id",
        ascending: false,
        startDate: (new Date(new Date().setDate(this.date.getDate() - 7)).toISOString().slice(0, 10) as any),
        endDate: (new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + 1).toISOString().slice(0, 10) as any),
        userId: undefined
    }

    constructor(props : ListViewProps){
        super(props, "/sportsbetting/bet-logs");
        this.service = getContainer().getSportsBetLogsService();

        if (this.state.listRequest){
            this.state = createInitialState( this.initialState, this.state = {lookupExpanded:true, ...this.state});
        }
    }
    onSubmit(): void {
        let listRequest : ListBetLogsRequest = Object.assign({},this.state.form);
        listRequest.offset = 0;
        
        console.log("listRequest;: ", listRequest)
        //this.updateListState(listRequest);
        setTimeout(()=> this.setState(({listRequest : listRequest, form : listRequest} as any)), 0);
    };

    onSubmitError() :  void {
        console.log("submit error!")
    }

    formDidUpdate(formModel: ListBetLogsRequest, validationMap?: any): void {
        if(!formModel.userId) delete formModel.userId;
        if(!formModel.id) delete formModel.id;
        if(!formModel.betId) delete formModel.betId;
        
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item : Event, action : string) : Promise<any> | undefined {
        return;
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.setState({listRequest:listRequest})
        }
    }
    getTitle() {
        return "List Bet Logs"
    }

    preset(preset: "day" | "week" | "month") {

        let filter: ListBetLogsRequest|undefined = this.state.listRequest;
        let today = new Date(new Date().setDate(new Date().getDate())).toISOString().slice(0,10);
        let yesterday = new Date(new Date().setDate(new Date().getDate()-1)).toISOString().slice(0,10);
        let sevenDaysAgo = new Date(new Date().setDate(new Date().getDate()-7)).toISOString().slice(0,10);
        let thirtyDaysAgo = new Date(new Date().setDate(new Date().getDate()-30)).toISOString().slice(0,10);

        switch(preset) {
            case "day":
                filter = {...this.state.form, startDate: yesterday as any, endDate: today as any};
                break;

            case "week":
                filter = {...this.state.form, startDate: sevenDaysAgo as any, endDate: today as any};
                break;

            case "month":
                filter = {...this.state.form, startDate: thirtyDaysAgo as any, endDate: today as any};
                break;
        }


        // this.updateListState({...filter});
        this.setState({form:filter})
    }

    getSearchByUserId() {
        return(
            <div className="row">
                <div className={"col-lg-6"}>
                    <div className="card-box">
                        <h4>Find By User Id</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="userId">
                                <FormInput model={"userId"} className={"form-control"} validators={[Validators.number()]}/>
                                <span className={"help-text"}>Finds logs by user id. Exact match only.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"}>Search</Submit>
                        </Form>
                    </div>

                </div>
                <div className={"col-lg-6"}>
                    <div className="card-box">
                        <h4>Find By Id</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="betId">
                                <FormInput model={"betId"} className={"form-control"} validators={[]}/>
                                <span className={"help-text"}>Finds bet by id. Exact match only.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"}>Search</Submit>
                        </Form>
                    </div>

                </div>
            </div>
        )
    }

    getSearchByFilter() {

        return(
            <div className="card-box expandable-box" style={!this.state.lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !this.state.lookupExpanded ? this.setState({lookupExpanded:true}) : null}>
                {this.state.lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); this.setState({lookupExpanded : false});}}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); this.setState({lookupExpanded : true});}}><i className="mdi mdi-plus"></i></a>
                )}

                <h4 className="header-title mb-3" onClick={()=>this.setState({lookupExpanded : !this.state.lookupExpanded})}>Advanced Search</h4>
                {this.state.lookupExpanded && (
                    <div>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <div className="row">
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label>Created</label>
                                        <h5>Presets</h5>
                                        <div>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("day")}>Day</span>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("week")}>Week</span>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("month")}>Month</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className={"form-group"}>
                                        <label htmlFor={"startDate"}>From:</label>
                                        <FormInput model={"startDate"} className={"form-control col-lg-6"} type={"date"} onFocus={() => this.clearForAdvanced()} />
                                        <label htmlFor={"endDate"}>To:</label>
                                        <FormInput model={"endDate"} className={"form-control col-lg-6"} type={"date"} onFocus={() => this.clearForAdvanced()} />
                                        <span className={"help-text"}>To but not included</span>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label>Bet Status</label>
                                        <SelectInput className="form-control  col-lg-4" model="statuses" size={[...Object.keys(BetStatus)].length} multiple={true}
                                                     values={[...Object.keys(BetStatus)]}
                                                     optional={true}
                                                     onFocus={() => this.clearForAdvanced()}>
                                        </SelectInput>
                                        <span className={"help-text"}>Search for bet based on their Status. CTRL select for multiple statuses.</span>
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="form-group">
                                    <Submit className={"btn btn-primary"}>Search</Submit>
                                    <button onClick={() => this.clearFilter()} className={"btn btn-secondary"}>Clear</button>
                            </div>
                        </Form>
                    </div>
                )}
            </div>
        )
    }

    clearForAdvanced() {
        this.setState({form: {...this.state.form}})
    }

    clearFilter() {
        this.setState({form: this.initialState})
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                {this.getSearchByUserId()}
                {this.getSearchByFilter()}
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}/>
            </Fragment>
        );
    }



}

export default withRouter(BetLogsListView)